<template>
  <div>
    <Header title="评价结果查看" type="0" route="/homeIndex"></Header>
    <div class="riqi">
      <van-field readonly clickable name="picker" :value="value" label="学年学期" placeholder="点击选择学期"
        @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
    </div>
    <div class="tab">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="xm" label="任课教师">
        </el-table-column>
        <el-table-column prop="kcmc" label="课程">
        </el-table-column>
        <el-table-column prop="xspjdj" label="学生评教">
        </el-table-column>
        <el-table-column prop="thpjdj" label="同行评价">
        </el-table-column>
        <el-table-column prop="jxdwpjdj" label="教学单位评价">
        </el-table-column>
        <el-table-column prop="ddpjdj" label="督导评价">
        </el-table-column>
        <el-table-column prop="jxbmpjdf" label="教学部门评价(加扣分)">
        </el-table-column>
        <el-table-column prop="kcpjjgdj" label="课程评价结果">
        </el-table-column>
        <el-table-column prop="xqpjjg" label="学期评价结果">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {
    Api
  } from "@/utils/axios";
  export default {
    data() {
      return {
        value: '',
        columns: [],
        showPicker: false,
        tableData: [],
      };
    },
    created() {
      this.getXnxq();
    },
    methods: {
      async getXnxq() {
        const res = await Api.getXnxq();
        res.data.forEach(item=>{
          this.columns.push(item.xnxq01id);
        });
        this.value = res.data[0].xnxq01id;
        this.getxqPjjgCk();
      },
      onConfirm(value) {
        this.value = value;
        this.showPicker = false;
        this.getxqPjjgCk();
      },
      async getxqPjjgCk() {
        const res = await Api.getxqPjjgCk({xnxq:this.value});
        this.tableData = res.data;
      },
    },
  };
</script>

<style>
  .riqi {
    margin-top: 70px;
  }

  .tab {
    margin-top: 30px;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/evaluationResults/index.vue